import React, { useState } from 'react'
import { type AssetHolderIdProps } from '../../pages/DashboardHome'
import { Alert, Box, Button, Card, CardActions, CardContent, Grid, Typography } from '@mui/material'
import { type DisbursementInstructionSummary } from '../../../../api/schema-dtos/AssetHolderDisbursementDomainDtos'
import CancelDisbursementInstructionComponent from './CancelDisbursementInstructionComponent'

interface DisbursementInstructionsComponentProps extends AssetHolderIdProps {
  pendingDisbursementInstructions: DisbursementInstructionSummary[]
  maxCardWidth: number
}

const DisbursementInstructionsComponent: React.FC<DisbursementInstructionsComponentProps> = ({
  assetHolderId,
  pendingDisbursementInstructions,
  maxCardWidth
}: DisbursementInstructionsComponentProps) => {
  const [instructionToCancel, setInstructionToCancel] = useState<number | null>(null)

  return (
    <>
      {pendingDisbursementInstructions.length === 0 &&
        <Box sx={{ maxWidth: maxCardWidth }}>
          <Alert severity="info" >There are currently no pending cash out requests.</Alert>
        </Box>
      }

      {pendingDisbursementInstructions.map((instruction: DisbursementInstructionSummary, index: number) => (
        <Card sx={{ maxWidth: maxCardWidth, mb: 2 }} variant={'outlined'} key={instruction.id}>
          <CardContent>
            <Grid container columnSpacing={2}>

              <Grid item md={6} xs={12}>
                <Box display={'flex'} justifyContent={'space-between'}>
                  <Typography variant={'body1'}>Requested:</Typography>
                  <Typography variant={'body2'}>{instruction.currencyCode} {instruction.requestedAmount}</Typography>
                </Box>

                <Box display={'flex'} justifyContent={'space-between'}>
                  <Typography variant={'body1'}>Payout:</Typography>
                  <Typography variant={'body2'}>{instruction.currencyCode} {instruction.payoutAmount}</Typography>
                </Box>

                <Box display={'flex'} justifyContent={'space-between'}>
                  <Typography variant={'body1'}>Fee:</Typography>
                  <Typography variant={'body2'}>{instruction.currencyCode} {instruction.feeAmount}</Typography>
                </Box>
              </Grid>

              <Grid item md={6} xs={12}>
                <Box display={'flex'} justifyContent={'space-between'}>
                  <Typography variant={'body1'}>Schedule:</Typography>
                  <Typography variant={'body2'}>{instruction.payoutSchedule}</Typography>
                </Box>
                <Box display={'flex'} justifyContent={'space-between'}>
                  <Typography variant={'body1'}>Request Date: </Typography>
                  <Typography variant={'body2'}>{instruction.createdAtFormatted}</Typography>
                </Box>
                <Box display={'flex'} justifyContent={'space-between'}>
                  <Typography variant={'body1'}> </Typography>
                  <Typography variant={'body2'}>{instruction.state}</Typography>
                </Box>
              </Grid>
              <Grid item md={12}>
                <Box display={'flex'} justifyContent={'space-between'} sx={{ mt: 2 }}>
                  <Typography variant={'body1'}>This request will be processed on <b>{instruction.nextWednesdayProcessingDate}</b>.  </Typography>
                </Box>
              </Grid>
            </Grid>

          </CardContent>

          <CardActions>
            { instruction.isCancellable && (
              <Box sx={{ display: 'flex', width: '100%' }} flexDirection={'row'} justifyContent={'flex-end'}>
                <Button variant={'outlined'} onClick={() => { setInstructionToCancel(instruction.id) }}>
                  Cancel Cash Out Instruction
                </Button>
              </Box>
            )}
          </CardActions>
        </Card>

      ))}

      {instructionToCancel !== null &&
        <CancelDisbursementInstructionComponent
          assetHolderId={assetHolderId}
          instructionId={instructionToCancel}
          onCloseDialog={() => { setInstructionToCancel(null) }}
        />
      }
    </>
  )
}

export default DisbursementInstructionsComponent
